/* WHICH `settings` COLUMNS ONE SAVE WRITES — only the ones it was handed.
 *
 * Until 2026-10-13 a save wrote EVERY column it knew, filled from whatever the
 * screen had loaded so far. Before her settings had loaded that was nothing,
 * so changing her business name in the first second or two blanked her display
 * name, archetype, logo and photo links and email choices. Found by reading
 * the code, not by her hitting it; pinned in settingsColumns.test.js.
 *
 * An upsert sets only the columns it names, so writing just the changed ones
 * leaves the rest of her row exactly as it was — loaded or not.
 *
 * Named, never spread: a key with no column (archetypePair is worked out from
 * the archetype on load) is dropped rather than failing the write.
 * BASIC columns exist from the start; BUSINESS ones arrived in supabase/0028,
 * and are split out so a save can retry without them (see App.saveSettings).
 */
const BASIC = {
  displayName: (v) => ["display_name", v || null],
  archetype: (v) => ["archetype", v || null],
  emailUpdates: (v) => ["email_updates", Boolean(v)],
  emailReminders: (v) => ["email_reminders", Boolean(v)],
};
const BUSINESS = {
  businessName: (v) => ["business_name", v || null],
  audience: (v) => ["audience", v || null],
  logoUrl: (v) => ["logo_url", v || null],
  photoUrl: (v) => ["photo_url", v || null],
};

function pick(map, updates) {
  const out = {};
  for (const [key, value] of Object.entries(updates || {})) {
    if (!map[key]) continue;
    const [col, v] = map[key](value);
    out[col] = v;
  }
  return out;
}

export function settingsColumns(updates) {
  return { basic: pick(BASIC, updates), business: pick(BUSINESS, updates) };
}
